/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Cholesterol from './cholesterol';
import CholesterolDetail from './cholesterol-detail';
import CholesterolUpdate from './cholesterol-update';
import CholesterolDeleteDialog from './cholesterol-delete-dialog';

const CholesterolRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Cholesterol />} />
    <Route path="new" element={<CholesterolUpdate />} />
    <Route path=":id">
      <Route index element={<CholesterolDetail />} />
      <Route path="edit" element={<CholesterolUpdate />} />
      <Route path="delete" element={<CholesterolDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CholesterolRoutes;
